import PageTemplate from "components/PageTemplate";
import I18n from "components/materials/I18n";
import classes from "./classes.module.scss";
import ProjectResponseResource from "common/resources/Project/ProjectResponseResource";
import ProjectDetails from "./ProjectDetails";
import Tabs from "./Tabs";
import { ETab, TabContext, TabProvider } from "components/pages/FeaturedProjects/contexts/Tab";
import { useContext } from "react";
import Votes from "./Votes";
import { ProjectProvider } from "components/pages/FeaturedProjects/contexts/Project";
import Actions from "./Actions";
import Medias from "./Medias";
import Team from "./Team";
import Forum from "./Forum";
import Casting from "./Casting";

type IProps = {
	project: ProjectResponseResource;
};

function ProjectTemplateContent(props: IProps) {
	const { isActiveTab } = useContext(TabContext);

	return (
		<PageTemplate tabTitle={I18n.trslt(I18n.asset.pages.project.page_title)} mainSectionClassName={classes["root"]}>
			<div className={classes["details-container"]}>
				<ProjectDetails project={props.project} />
			</div>

			<div className={classes["tabs-container"]}>
				<Tabs />
				<div className={classes["active-tab-content"]}>
					{isActiveTab(ETab.VOTES) && <Votes />}
					{isActiveTab(ETab.ACTIONS) && <Actions />}
					{isActiveTab(ETab.FORUM) && <Forum />}
					{isActiveTab(ETab.CASTING) && <Casting />}
					{isActiveTab(ETab.MEDIA) && <Medias />}
					{isActiveTab(ETab.TEAM) && <Team />}
				</div>
			</div>
		</PageTemplate>
	);
}

export default function ProjectTemplate(props: IProps) {
	return (
		<ProjectProvider>
			<TabProvider defaultTab={ETab.VOTES} enabledTabs={[ETab.VOTES, ETab.ACTIONS, ETab.FORUM, ETab.CASTING, ETab.MEDIA, ETab.TEAM]}>
				<ProjectTemplateContent {...props} />
			</TabProvider>
		</ProjectProvider>
	);
}
